export enum ETipoDocumento {
  DNI = 'DNI',
  CE = 'CE',
  RUC = 'RUC',
  PASAPORTE = 'PASAPORTE',
  PERMISO_TEMPORAL_PERMANENCIA = 'PERMISO_TEMPORAL_PERMANENCIA',
  DOCUMENTO_IDENTIDAD_EXTRANJERO = 'DOCUMENTO_IDENTIDAD_EXTRANJERO',
  OTRO = 'OTRO',
}
